
if($('.filter-section').length){
    mhFilter();
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        mhFilter();
    }); 
    
}

function mhFilter(){
    $('html').on('click', '#filters .filter-section h4', function(){
        $(this).closest('.filter-section').toggleClass('openIt')
    })
    $('.slider-wrapper').addClass('filter-section')
    $('.filter-section').addClass('openIt')
    var otherElements = $('.filter-section').not(openFilters);
    otherElements.removeClass('openIt');
    
    $('.filter-section').each(function(){
        if($(this).find('.filter-label.active').length){
            $(this).addClass('openIt')
        }
    })
}

